import React from 'react';
import { PropTypes } from 'prop-types';
import styled from 'styled-components';

const COLOR = '#f15a29';

const SVG = styled.svg`
  height: ${({ height }) => height};
`;

const Path = styled.path`
  fill: black;
`;

const OPath = styled.path`
    fill: ${COLOR};
`;

const Container = styled.div`
  display: flex;
`;

const Logo = ({ height }) => (
    <Container>
        <SVG height={height} viewBox="0 0 470.45 76.33">
            <Path d="M.59 64.15c.53-.64 1.06-1.38 1.59-2 1.06-1.38 2.23-2.23 3.71-.95.74.63 8.48 8.05 17.92 8.05 8.59 0 14.21-5.4 14.21-11.66 0-7.31-6.37-11.66-18.56-16.75C7.81 35.73.81 30.98.81 18.88.81 11.67 6.54 0 23.39 0a34.67 34.67 0 0 1 18.13 5.41c.64.32 1.91 1.59.64 3.61-.42.63-.85 1.37-1.27 2-1 1.48-2 1.91-3.71.95-.75-.42-7.42-4.87-13.89-4.87-11.24 0-14.63 7.21-14.63 11.66 0 7.1 5.41 11.24 14.31 14.95 14.31 5.83 23.54 11.24 23.54 23.53 0 11-10.5 19.09-22.9 19.09a34.58 34.58 0 0 1-22.37-8.59c-.86-.76-1.92-1.58-.65-3.59z" />
            <OPath d="M94.52-.02a38.17 38.17 0 1 1-38.06 38.28A38.11 38.11 0 0 1 94.52-.02zm0 68.92a30.75 30.75 0 1 0-30.64-30.64 30.82 30.82 0 0 0 30.64 30.66z" />
            <Path d="M148.91 3.08a2 2 0 0 1 2-2h4.13a2.1 2.1 0 0 1 2 2v65.09h30.53a2 2 0 0 1 2 2v3.07a2 2 0 0 1-2 2h-36.65a2 2 0 0 1-2-2zM182.94 3.82a1.87 1.87 0 0 1 1.8-2.76h4.24a2 2 0 0 1 1.8 1.17l26.4 59.37h.42L244 2.23a2.09 2.09 0 0 1 1.81-1.17h4.24a1.87 1.87 0 0 1 1.8 2.76l-32.23 71.35a2 2 0 0 1-1.8 1.17h-1.01a2.15 2.15 0 0 1-1.81-1.17zM248.98 72.52l32.23-71.35A1.91 1.91 0 0 1 283.02 0h1.06a1.91 1.91 0 0 1 1.8 1.17l32 71.35a1.88 1.88 0 0 1-1.81 2.76h-4.26a2 2 0 0 1-1.8-1.17l-7.84-17.49h-37.6l-7.76 17.49a2 2 0 0 1-1.8 1.17h-4.2a1.88 1.88 0 0 1-1.83-2.76zm50.36-22.48c-5.19-11.55-10.28-23.21-15.48-34.77h-.84l-15.48 34.77zM329.45 1.91a2 2 0 0 1 2-1.91h2.65l47.82 59.59h.21V3.08a2 2 0 0 1 2-2h3.72a2.09 2.09 0 0 1 2 2v71.35a2 2 0 0 1-2 1.91h-1.91l-48.67-60.75h-.1v57.67a2 2 0 0 1-2 2h-3.71a2.09 2.09 0 0 1-2-2zM401.33 72.52l32.23-71.35a1.88 1.88 0 0 1 1.8-1.17h1.06a1.91 1.91 0 0 1 1.8 1.17l32 71.35a1.87 1.87 0 0 1-1.8 2.76h-4.25a2 2 0 0 1-1.8-1.17l-7.84-17.49h-37.62l-7.74 17.49a2 2 0 0 1-1.8 1.17h-4.24a1.87 1.87 0 0 1-1.8-2.76zm50.36-22.48c-5.2-11.55-10.29-23.21-15.48-34.77h-.85l-15.48 34.77z" />
        </SVG>
    </Container>
);

Logo.propTypes = {
    height: PropTypes.string,
};

Logo.defaultProps = {
    height: '24px',
};

export default Logo;



// WEBPACK FOOTER //
// ./src/components/Logo/index.js